import { useMutation } from '@tanstack/react-query';
import automateAxios from '../../../utils/automateAxios';
import { MutationKeys } from '../../mutation/mutation.enum';

const downloadResult = async (jobId: string): Promise<void> => {
  const response = await automateAxios.get(`/jobs/${jobId}/result`, {
    responseType: 'blob',
  });

  const disposition: string | undefined = response.headers['content-disposition'];
  let filename = 'output.xlsx';
  if (disposition) {
    const utf8Match = disposition.match(/filename\*=utf-8''([^;]+)/i);
    const stdMatch = disposition.match(/filename="?([^";]+)"?(?:;|$)/i);
    if (utf8Match?.[1]) {
      try {
        filename = decodeURIComponent(utf8Match[1]);
      } catch {
        filename = utf8Match[1];
      }
    } else if (stdMatch?.[1]) {
      filename = stdMatch[1].trim();
    }
  }

  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const useDownloadResult = () => {
  return useMutation({
    mutationKey: [MutationKeys.DOWNLOAD_AUTOMATION_RESULT],
    mutationFn: downloadResult,
  });
};

export default useDownloadResult;
